import { Components } from '@mui/material/styles';

const MIN_DATE = new Date(2015, 0, 1);
const MAX_DATE = new Date(new Date().getFullYear(), 11, 31);

const components = (theme: any): Components => ({
  MuiTableCell: {
    styleOverrides: {
      head: {
        fontSize: '14px',
        fontWeight: 500
      }
    }
  },
  // @ts-ignore — x-date-pickers components are not in @mui/material's Components type
  MuiDatePicker: { defaultProps: { minDate: MIN_DATE, maxDate: MAX_DATE } },
  MuiDateTimePicker: { defaultProps: { minDate: MIN_DATE, maxDate: MAX_DATE } }
});

export default components;
